import { style } from '@vanilla-extract/css'

const heading = style({
  fontFamily: 'Inter Variable, sans-serif',
  fontWeight: '700',
  fontSize: '24px',
  lineHeight: '2.1',
})

export const styles = { heading }
